module.exports = __webpack_public_path__ + "img/meh.2b41c207.svg";